import { combineReducers } from "redux";
import DrawerReducer from "./drawerReducer";
import varValueReducer from "./varValueReducer";   // ⭐ ADD THIS

export default combineReducers({
  DrawerReducer,
  varValue: varValueReducer,                       // ⭐ ADD THIS
});
